export default class SurfacePickUp extends Core.Component {
  onMount() {
    const drawerModal = Core.Components.getComponent('drawer-modal');

    if (!drawerModal) return;

    this._drawerFlyout = drawerModal.createFlyout();

    const embedModalBtn = this.query('button');

    if (!embedModalBtn) return; // We're not looking at a variant with surface pick up

    const drawerHeaderFragment = this.el.querySelector('[data-drawer-header-template]').content.cloneNode(true);
    const drawerFragment = this.el.querySelector('[data-drawer-template]').content.cloneNode(true);
    const { el: embedModalBtnEl } = embedModalBtn;

    this.events.register(embedModalBtnEl, 'click', e => {
      e.stopPropagation();
      e.preventDefault();

      this._drawerFlyout
        .then(drawerFlyout => {
          if (!drawerFlyout) return;

          drawerFlyout.populateHeading(drawerHeaderFragment);
          drawerFlyout.populateContent(drawerFragment);
          drawerModal.openFlyout(drawerFlyout, embedModalBtnEl);

          this.events.register(drawerFlyout.el, 'surface-pick-up-drawer:close', () => drawerModal.closeFlyout(drawerFlyout));
        });
    });
  }

  onDismount() {
    super.onDismount();

    if (this._drawerFlyout) {
      this._drawerFlyout.then(drawerFlyout => drawerFlyout.destroy());
    }
  }
}
